"use strict";
import React from "react";
import ReactDOM from "react-dom";
import { Router, Route } from "react-router";
import FactorInvoiceExtractDataPage from "../factor_invoice_extract_data_page";
const ID_ATTR = "factor-invoice-id";
const HAS_MORE_GROUPS_ATTR = "has-more-groups";
const ADVANCES_GROUPS_ATTR = "advances-groups";
const DONE_URL_ATTR = "done-url";
const TAG = "ht-factor-invoice";
class FactorInvoiceElement extends HTMLElement {
  static get observedAttributes() {
    return [ID_ATTR, HAS_MORE_GROUPS_ATTR, ADVANCES_GROUPS_ATTR, DONE_URL_ATTR];
  }
  connectedCallback() {
    this.renderFromAttribute();
  }
  attributeChangedCallback() {
    this.renderFromAttribute();
  }
  disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }
  renderFromAttribute() {
    const factorInvoiceId = this.getAttribute(ID_ATTR);
    const hasMoreGroups = this.getAttribute(HAS_MORE_GROUPS_ATTR);
    const advancesGroups = this.getAttribute(ADVANCES_GROUPS_ATTR);
    if (!factorInvoiceId || !hasMoreGroups || !advancesGroups) return;
    const PageWrapper = (routeProps) => React.createElement(FactorInvoiceExtractDataPage, {
      params: { factorInvoiceId, hasMoreGroups },
      location: routeProps.location,
      embedded: true,
      // Elm's pushUrl port calls window.history.pushState directly, so
      // $hubtranHistory never sees the navigation to this invoice and the
      // location above still describes the dashboard we came from, without
      // its onDone. The host hands us the return URL instead.
      //
      // Read at render time rather than captured above: this attribute is
      // optional, so it cannot join the guard below without breaking the
      // batch host, which never emits it. Reading it late means a value that
      // arrives after the first render is still picked up.
      onDone: this.getAttribute(DONE_URL_ATTR) || void 0,
      // Only a batch host advances between groups. Standalone hosts emit
      // advances-groups="false", leaving the callback undefined so completion
      // falls back to React's own dashboard navigation.
      onGroupCompleted: advancesGroups === "true" ? () => {
        this.dispatchEvent(
          new CustomEvent("group-completed", { bubbles: true })
        );
      } : void 0
    });
    ReactDOM.render(
      React.createElement(
        Router,
        { history: window.$hubtranHistory },
        React.createElement(Route, { path: "*", component: PageWrapper })
      ),
      this
    );
  }
}
if (!customElements.get(TAG)) {
  customElements.define(TAG, FactorInvoiceElement);
}
